import React, { useEffect } from  "react";
import { CONSTANTS } from "../../../../../constants/Constant";
import RouteManager, { PAGE_ROUTES } from "../../../../../managers/RouteManager";
import IRASService  from "../../../../../services/IRASService";
import {showToast, TOAST_TYPE, DKSpinner, showAlert} from "deskera-ui-library";
import { IRAS_MESSAGES } from "../SGReportsConstant";
import { IRAS_TAB } from "../../../../../constants/Enum";

const ProxyAISSubmission = (props) => {

    const routePopup = [
        {
            title: "Cancel",
            className: "bg-gray1 border-m",
        },
        {
            title: "Take me there",
            className: "bg-red text-white ml-r",
            onClick: () => routeToAISSubmissionLogs(),
        },
    ];

    useEffect(() => {
        RouteManager.setPresenter({props:props})
        const authorizationData = getAuthorizationFromLocation();
        if(authorizationData && authorizationData.includes(CONSTANTS.CODE) && authorizationData.includes(CONSTANTS.STATE)) {
            postAutherizationCode(authorizationData);
          } else {
            RouteManager.navigateToPage(PAGE_ROUTES.DASHBOARD);
          }

    },[]);

    const getAuthorizationFromLocation = () => {
        let currentLocation = props?.location?.pathname;
        let routingArray = props?.location?.search ? props?.location?.search.split("?") : '';
        if (routingArray.length > 0) {
            if (currentLocation === PAGE_ROUTES.REPORT.SG.IRAS_CALL_BACK) {
                IRASService.irasCallBackURL = PAGE_ROUTES.REPORT.SG.IRAS_CALL_BACK;
                IRASService.authenticationData = routingArray[1] ? routingArray[1] : "";
            }
        }
        return IRASService.authenticationData;
    }

    const routeToAISSubmission = () => {
        setTimeout(() => {
            props.history.push(PAGE_ROUTES.REPORT.SG.IRAS_AIS_SUBMISSION, {
                tabIndex: 2,
              });
        },5000)
      }
    
    const postAutherizationCode = (authorizationData) => {
          IRASService.postAuthorizationCode(authorizationData, false).then((response) => {
            if (response) {
              let message = '';
              let isSuccess = false;
              response.forEach(element => {
                if(element['status'] == 'SUCCESS') {
                  isSuccess = true;
                  if(element['action'] == CONSTANTS.VALIDATE_AND_SUBMIT) {
                    message = IRAS_MESSAGES.SUBMISSION_SUCCESSFULL;
                  } else if(element['action'] == CONSTANTS.VALIDATE) {
                    message = IRAS_MESSAGES.VALIDATION_SUCCESSFULL;
                  }
                } else {
                  isSuccess = false;
                  if(element['action'] == CONSTANTS.VALIDATE_AND_SUBMIT) {
                    message = IRAS_MESSAGES.SUBMISSION_FAIL;
                  } else if(element['action'] == CONSTANTS.VALIDATE) {
                    message = IRAS_MESSAGES.VALIDATION_FAIL;
                  }
                }
              });
              if(isSuccess) {
                  showToast(message, TOAST_TYPE.SUCCESS);
                  routeToAISSubmission();
              } else {
                  showAlert(
                      "IRAS details of selected users have failed submission.",
                      "Please check submission log for more details.",
                      routePopup

                  )
              }
            }
          },
            error => {
              showAlert(
                "IRAS details of selected users have failed submission.",
                "Please check submission log for more details.",
                routePopup

                )
            });
      }

    const routeToAISSubmissionLogs = () => {
        RouteManager.navigateToPage(
            PAGE_ROUTES.REPORT.SG.IRAS_AIS_SUBMISSION,
                        `tabIndex=2`
        )
    }

    return(
        <>
            <div className="parent-width">
                <DKSpinner className="pt-xxl pb-xxl mt-xxl" />
            </div>
        </>
    )
}

export default ProxyAISSubmission;